"use client";

import { cn } from "@/lib/utils";

export type ScorecardVariant = "feed" | "timeline";

type ScorecardShellProps = {
  children: React.ReactNode;
  variant?: ScorecardVariant;
  className?: string;
};

export function ScorecardShell({
  children,
  variant = "feed",
  className,
}: ScorecardShellProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-surface p-3",
        variant === "feed" ? "mt-3" : "mt-2",
        className,
      )}
    >
      {children}
    </div>
  );
}
